import { Routes, Route, Navigate } from "react-router-dom";
import QuickStart from '../pages/Docs/Quickstart';
import Commands from '../pages/Docs/Commands';
import Configurations from '../pages/Docs/Configurations';
import Policy from '../pages/Docs/Policy';
import Terms from '../pages/Docs/Terms';

function Docs() {
  return (
    <Routes>
      <Route path="/docs" element={<Navigate to="/docs/quickstart" replace />}/>
      <Route path="/docs/quickstart" element={<QuickStart />}/>
      <Route path="/docs/commands" element={<Commands />}/>
      <Route path="/docs/configurations" element={<Configurations />}/>
      <Route path="/docs/terms" element={<Terms />}/>
      <Route path="/docs/policy" element={<Policy />}/>
    </Routes>
  )
}

export default Docs